goog.provide("shadow.js.shim.module$src$svg$controls$watch_svg");
goog.provide("module$shadow_js_shim_module$src$svg$controls$watch_svg");
shadow.js.shim.module$src$svg$controls$watch_svg = shadow.js.nativeProvides["src/svg/controls/watch.svg"] = shadow$bridge("src/svg/controls/watch.svg");
module$shadow_js_shim_module$src$svg$controls$watch_svg.default = shadow.js.shim.module$src$svg$controls$watch_svg;
